<script lang='ts'>
export default {
  name: 'KkStatusMessage',
}
</script>
<script setup lang='ts'>
import {
  computed,
} from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface Props {
  status: 'error' | 'progress' | 'complete' | 'closed'
  errorCount?: number
}
const props = defineProps<Props>()

const statusMsg = computed<string>(() => {
  // errorの場合、店舗数も表示する「〇〇店舗でエラーがありました」か「エラーがありました」の2択がある
  if (props.status === 'error') {
    if (props.errorCount) {
      return t('pages.CompaniesStorePost.index.status.' + 'error', { count: props.errorCount })
    } else {
      return t('pages.CompaniesStorePost.index.status.' + 'simpleError')
    }
  }
  return t('pages.CompaniesStorePost.index.status.' + props.status)
})
</script>

<template>
  <p class="statusMsg" :class="{ 'statusMsg__error': props.status === 'error' }">
    <span :class="`statusMark__${props.status}`" class="statusMark" />
    {{ statusMsg }}
  </p>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.statusMsg__error {
  color: $color-accent-primary;
}
.statusMark {
  border-radius: 50%;
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 2px;
  &__error {
    background: $color-accent-primary;
  }
  &__complete {
    background: $complete-color;
  }
  &__progress {
    background: #D2D5DB;
  }
  &__closed {
    background: #D2D5DB;
  }
  &__rejected {
    background: $color-accent-primary;
  }
  &__requesting {
    background: $complete-color;
  }
  &__draft {
    background: #D2D5DB;
  }
}
</style>
